import { Component, OnInit, Inject } from '@angular/core';
import { ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportTemplateDesignComponent } from 'src/app/report-template/report-template-design/report-template-design.component';
import { ReportTemplate } from 'src/app/_objects/report-template';
import { CommonSnackBarService } from 'src/app/_services/common-snack-bar.service';
import { SpinnerService } from '@osc-utils/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from 'src/app/_services/lang-update.service';

@Component({
    selector: 'app-report-template-move-confirm-dialog',
    templateUrl: './report-template-move-confirm-dialog.component.html',
    styleUrls: ['./report-template-move-confirm-dialog.component.scss'],
    providers: [
        ReportTemplateDesignService
    ],
    standalone: false
})

export class ReportTemplateMoveConfirmDialogComponent implements OnInit {
  isMove: boolean;
  isError: boolean;
  component: ReportTemplateDesignComponent;
  constructor(
    public dialogRef: MatDialogRef<ReportTemplateMoveConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: CommonSnackBarService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private langService: LangUpdateService
  ) {
    this.langService.prepare(this, this.translate);

  }
  ngOnInit() {
    this.isMove = this.data.isMove;
    this.isError = this.data.isError;
    this.component = this.data.component;
  }
  save() {
    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    this.component.designService.saveReportTemplate()
      .subscribe((template: ReportTemplate) => {
      },
        error => {
          console.log(error);
          this.snackBar.open(this.translate.instant('moveconfirmDialog.saveFailed'));
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
          this.dialogRef.close('');
        },
        () => {
          this.snackBar.open(this.translate.instant('moveconfirmDialog.savedSuccessfully'));
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
          this.dialogRef.close(true);
        });
  }
}
